import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
// You can declare a mixin as the same style as components.

@Component
export default class fileItem extends Vue {
    @Prop() index: number;
    @Prop() mode: string;
    @Prop() file: any;
    @Prop() searchKey: string;

    @Prop({ default: "file" }) readonly type!: string;

    saveInputName: string = "";
    get pcSaveInput() {
        return this.$store.state.pcSaveInput;
    }
    get userInfo() {
        return this.$store.state.userInfo;
    }
    get isOpenMyColud() {
        return this.$store.state.isOpenMyColud;
    }

    get filePublish() {
        if (this.file.publish) {
            return this.file.publish;
        } else if (this.file.review_status) {
            return this.file.review_status;
        } else if (this.file.info && this.file.info.publish) {
            return this.file.info.publish;
        } else {
            return false;
        }
    }

    get fileName() {
        if (this.type === "share" || this.type === "publishFile") {
            return this.file.title;
        } else {
            return this.file.name;
        }
    }
    get searchFileName() {
        if (this.searchKey) {
            return this.fileName
                .replace(new RegExp(`${this.searchKey}`, "g"), `%%${this.searchKey}%%`)
                .split("%%")
                .filter((item) => item != "");
        }
    }
    formatDate(str) {
        const addZero = (num) => {
            return (num < 10 && `0${num}`) || num;
        };
        let date = new Date(str);
        let Y = date.getFullYear();
        let M = date.getMonth() + 1;
        let D = date.getDate();
        let H = date.getHours();
        let Min = date.getMinutes();
        let sec = date.getSeconds();
        return `${Y}/${addZero(M)}/${addZero(D)} ${addZero(H)}:${addZero(Min)}:${addZero(sec)}`;
    }
    get fileTime() {
        if (this.type === "recycle") {
            return this.formatDate(this.file.deleted_at);
        } else if (this.type === "share") {
            return this.formatDate(this.file.updated_at);
        } else if (this.type === "openRecord" || this.type === "shareToMe") {
            return this.formatDate(this.file.opened_at);
        } else if (this.type === "publishFile") {
            return this.formatDate(this.file.created_at);
        } else if (this.type === "star") {
            return this.formatDate(this.file.updated_at);
        } else if (this.type === "team") {
            return this.formatDate(this.file.info.created_at);
        } else {
            return this.formatDate(this.file.lastModified);
        }
    }

    get fileImg() {
        let lang = this.lang == "zh" ? "zh" : "en";
        if (lang == "zh" && this.file.info && this.file.info.encrypt) {
            return require(`@/home/assets/img/files/locked-files-${lang}.svg`);
        }
        if (this.type === "share") {
            if (this.isPrivate) {
                return window["GLOBAL"].PUBLIC_OSS_HOST + this.file.img;
            }
            return this.file.url
                ? window["GLOBAL"].PUBLIC_OSS_HOST + this.file.url + "preview.png"
                : require(`@/home/assets/img/files/default-files-${lang}.svg`);
        } else if (this.type === "publishFile") {
            return window["GLOBAL"].PUBLIC_OSS_HOST + this.file.url + "thumb.png";
        } else {
            if (this.isPrivate) {
                return (
                    window["GLOBAL"].PRIVATE_OSS_HOST +
                    this.file.info.img +
                    `?${this.file.info.img_sign || this.file.info.img_down_sign || this.file.info.imgSign}`
                );
            } else if (this.file.info) {
                return this.onlineFilesImg(
                    this.file.info.img,
                    this.file.info.down_exp || this.file.info.downExp,
                    this.file.info.img_sign || this.file.info.img_down_sign || this.file.info.imgSign,
                    this.file.lastModified,
                    !!(this.file.info.img_sign || this.file.info.img_down_sign)
                );
            } else {
                return require(`@/home/assets/img/files/default-files-${lang}.svg`);
            }
        }
    }
    get isAd() {
        return this.$store.state.isAd;
    }

    setPCOpenRecord(name) {
        let userP = JSON.parse(JSON.stringify(this.$store.getters.apiParam));
        delete userP.islogin;
        let params = Object.assign({ obj: name, size: 0, platform: this.$store.state.publicStore.runPlatform }, userP);
        this.$edApi
            .getCloudFileSign(params)
            .then((res) => {
                if (res.msg === "file num over limit") {
                } else if (res.msg === "storage space not enough") {
                } else {
                    let params = Object.assign({ obj_id: res.data.id }, userP);
                    this.$edApi.addOpenRecord(params).then((e) => {
                        window.opener?.postMessage(
                            {
                                type: "updateMyfile",
                                updateRecentFile: true,
                            },
                            location.origin
                        );
                    });
                }
            })
            .catch((err) => {});
    }

    trackOpenFrom() {
        if (this.isPC) return;
        switch (this.type) {
            case "openRecord":
                this.sensors.track("openRecent", {
                    Catalogues: "Workbench",
                });
                break;
            case "star":
                this.sensors.track("openStar", {
                    Catalogues: "Workbench",
                });
                break;
            case "files":
                this.sensors.track("personalCloud", {
                    Catalogues: "Workbench",
                });
                break;
            case "openRecord":
                break;
            case "openRecord":
                break;
        }
    }

    openFiles(item, urlHash = "") {
        if (this.type === "recycle" || this.pcSaveInput) {
            return;
        }
        if (!item) return;
        this.trackOpenFrom();
        this.$track(this.$route.name.toLowerCase(), "open file", this.$store.state.layoutMode);
        let ts: any = this;
        let lang = this.internal ? "" : `?lang=${this.lang}`;
        let fileName = "&name=";
        if (item.name) {
            fileName += item.name;
        } else if (item.title) {
            // share file
            fileName += item.title;
        } else {
            let key = item.key || item.obj;
            fileName += key.match(/[^\/]*(?=\.eddx)/i)[0];
        }
        if (item.info && item.info.edit === false) {
            let fileKey = item.key;
            fileName += "&preview=1&fileLimitTip=1";
            const userInfo = this.isPC
                ? `&custom=${btoa(
                      JSON.stringify({
                          id: this.userInfo.user_id,
                          token: this.userInfo.token,
                      })
                  )}`
                : "";
            this.$store.commit("setState", {
                type: "showReadOnlyModal",
                data: true,
            });
            let base = (<any>this.$router).options.base;
            if (base == "/pc/") {
                base = "/online/";
            }
            this.$store.commit("setState", {
                type: "readOnlyTempFileLink",
                data: window.location.origin + base + "app.html?" + ts.$zipFileName("obj=" + fileKey + fileName) + userInfo + `#${urlHash}`,
            });
            return;
        }

        if (this.isPC) {
            if (this.type === "share") {
                if (this.file.domain.indexOf("?") != -1) {
                    lang = lang.replace("?", "&");
                }
                (<any>window).$qt.jsCallOpenUrl(this.file.domain + this.file.uuid + lang);
                return;
            }
            if (this.type === "shareToMe") {
                if (item.domain.indexOf("?") != -1) {
                    lang = lang.replace("?", "&");
                }
                (<any>window).$qt.jsCallOpenUrl(item.domain + item.uuid + lang);
                return;
            }
            // if(item.info && item.info.edit === false) {
            //     if(this.$isBiggerVersion('11.5.5')) {
            //         (<any>window).$qt.jsCallNewUpgradeToPremium && (<any>window).$qt.jsCallNewUpgradeToPremium(8);
            //     } else {
            //         this.$store.commit("toPublicStatus", {
            //             type: "showUpgrade",
            //             data: 'fileNum'
            //         });
            //     }
            //     return
            // }
            let pcLockStatus = this.$store.state.pcLockStatus;
            if (pcLockStatus) {
                return;
            }
            this.$store.commit("setPcLockStatus", true);

            let userP = this.$store.getters.apiParam;
            let key = this.type === "share" ? item.obj : this.type === "publishFile" ? item.obj : item.key;
            let filePath = key.match(/[^\/]+\/[^\/]+\/(.+)/) && key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
            let params = Object.assign({ obj: filePath }, userP);
            this.$edApi
                .getDownFileAddress(params)
                .then((signInfo) => {
                    let obj = key;
                    //中文站用的oss，英文站用的aws，通过getSignature得到的数据不一样
                    let paramForPc;
                    if (this.internal) {
                        let { sign, exp } = signInfo.data;
                        sign = encodeURIComponent(sign);
                        paramForPc = {
                            fileName: item.name,
                            sign,
                            exp,
                            obj,
                            type: "open",
                            from: "cloud",
                            accessid: this.OSSAccessKeyId,
                        };
                    } else {
                        let { path, query } = signInfo.data;
                        paramForPc = {
                            fileName: item.name,
                            path,
                            query,
                            type: "open",
                            from: "cloud",
                            accessid: this.OSSAccessKeyId,
                        };
                    }
                    if (urlHash == "publish") {
                        paramForPc.action = "publish";
                        paramForPc.from = "publish";
                    }
                    this.setPCOpenRecord(obj);
                    (<any>window).$qt.jsCallCloudFileOperate(JSON.stringify(paramForPc));
                    if (urlHash != "publish") {
                        (<any>window).$qt.jsCallUploadData &&
                            (<any>window).$qt.jsCallUploadData(
                                JSON.stringify({
                                    type: "Open",
                                    action: "personalCloud",
                                })
                            );
                    }
                })
                .catch(() => {
                    let ts: any = this;
                    ts.cleanMultipleStatus && ts.cleanMultipleStatus(true);
                    this.$store.commit("setPcLockStatus", false);
                    this.$edMessage.warning(this.$t("networkError"));
                });
        } else if (this.type === "shareToMe") {
            if (this.openInTabs) {
                location.href = item.domain + item.uuid;
            } else {
                if (item.domain.indexOf("?") != -1) {
                    lang = lang.replace("?", "&");
                }
                window.openPlus(item.domain + item.uuid + lang, "_blank");
            }
        } else {
            if (this.type === "share") {
                if (this.openInTabs) {
                    location.href = item.domain + item.uuid;
                } else {
                    if (item.domain.indexOf("?") != -1) {
                        lang = lang.replace("?", "&");
                    }
                    window.openPlus(item.domain + item.uuid + lang, "_blank");
                }
            } else {
                let fileKey = item.key;
                if (this.type == "publishFile") {
                    fileKey = item.obj;
                }
                if (this.openInTabs) {
                    if ((item.info && item.info.edit === false) || (this.isTeamsApp && !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/))) {
                        // 进入仅预览模式
                        fileName += "&preview=1";
                    }
                    if (this.type == "team") {
                        let teamId = this.file.info.team_id;
                        let objId = this.file.info.id;
                        localStorage.setItem("editTeamId", teamId);
                        localStorage.setItem("editTeamObjId", objId);
                        urlHash = "editTeam";
                    }
                    location.href =
                        window.location.origin +
                        (<any>this.$router).options.base +
                        "app.html?" +
                        ts.$zipFileName("obj=" + fileKey + fileName) +
                        `#${urlHash}`;
                    return;
                }
                if (item.info && item.info.edit === false) {
                    // 进入仅预览模式
                    fileName += "&preview=1";
                }
                let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                if (openTabs.includes(fileKey)) {
                    try {
                        let tab = window.open("", fileKey);
                        if (tab.location.href === "about:blank") {
                            if (this.type === "team") {
                                let teamId = this.file.info.team_id;
                                let objId = this.file.info.id;
                                let file_key = this.file.info.file_key;
                                let param = Object.assign({ teamId, objId, file_key }, this.$store.getters.apiParam);
                                // 隔一分钟获取锁
                                // window["getEditLockTimer"] = setInterval(()=>{
                                //     this.$edApi.getEditTeamLock(param).then((data)=>{
                                //         if(data.msg === "Owned by someone"){
                                //             this.$edMessage.warning(data.data.nick_name + "  " + this.$t("teamEditWarn"))
                                //             clearInterval(window["getEditLockTimer"]);
                                //             return;
                                //         }
                                //     })
                                //     console.log("timer",window["getEditLockTimer"])
                                // }, 5000)
                                localStorage.setItem("editTeamId", teamId);
                                localStorage.setItem("editTeamObjId", objId);
                                (tab.location.href =
                                    window.location.origin +
                                    (<any>this.$router).options.base +
                                    "app.html?" +
                                    ts.$zipFileName("obj=" + file_key + fileName) +
                                    "#editTeam"),
                                    fileKey;
                                window["editCloseTimer"] = setInterval(() => {
                                    if (tab.closed) {
                                        this.$edApi.relEditTeamLock(param);
                                        clearInterval(window["editCloseTimer"]);
                                        // clearInterval(window["getEditLockTimer"]);
                                        // window.alert('clear getEditLockTimer')
                                    }
                                }, 5000);
                                // })
                            } else {
                                this.$store.commit("addWin", tab);
                                tab.location.href =
                                    window.location.origin +
                                    (<any>this.$router).options.base +
                                    "app.html?" +
                                    ts.$zipFileName("obj=" + fileKey + fileName) +
                                    `#${urlHash}`;
                                this.sensors.track("openSuccess", {
                                    Catalogues: "Workbench",
                                });
                            }
                        }
                    } catch (e) {
                        this.toRedirectNew(fileKey, fileName, urlHash);
                    }
                } else {
                    this.toRedirectNew(fileKey, fileName, urlHash);
                }
            }
        }
    }
    toRedirectNew(key, fileName, urlHash = "") {
        let ts: any = this;
        let maxAction = this.$store.state.appState;
        if (maxAction) {
            if (maxAction == "create") (<any>this).$edMessage.success(this.$t("create"));
            // else if(maxAction == 'share')
            //     (<any>this).$edMessage.success(this.$t('openTips'));
            return;
        }
        let fileObj = this.isAd ? "obj=" + key + `&from=ad` : "obj=" + key;
        if (this.type === "team") {
            let teamId = this.file.info.team_id;
            let objId = this.file.info.id;
            let file_key = this.file.info.file_key;
            let param = Object.assign({ teamId, objId, file_key }, this.$store.getters.apiParam);
            // this.$edApi.getEditTeamLock(param).then((data)=>{
            //     if(data.msg === "Owned by someone"){
            //         this.$edMessage.warning(data.data.nick_name + "  " + this.$t("teamEditWarn"))
            //         return;
            //     }
            localStorage.setItem("editTeamId", teamId);
            localStorage.setItem("editTeamObjId", objId);
            let newTab: any = window.openPlus(
                window.location.origin + (<any>this.$router).options.base + "app.html?" + ts.$zipFileName(fileObj + fileName) + "#editTeam",
                key
            );
            window["editCloseTimer"] = setInterval(() => {
                if (newTab.closed) {
                    this.$edApi.relEditTeamLock(param);
                    clearInterval(window["editCloseTimer"]);
                }
            }, 5000);
            let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
            if (!openTabs.includes(key)) {
                openTabs.push(key);
            }
            localStorage.setItem("openTabs", JSON.stringify(openTabs));
            // })
        } else {
            this.$gaTrack("openFileProcess_enterCanvas", `fileSource: existEddxFile}`);
            fileObj += "&file_source=existEddxFile&template_type=notTemplate";
            let newTab: any = window.openPlus(
                window.location.origin + (<any>this.$router).options.base + "app.html?" + ts.$zipFileName(fileObj + fileName) + `#${urlHash}`,
                key
            );
            let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
            if (!openTabs.includes(key)) {
                openTabs.push(key);
            }
            this.$store.commit("addWin", newTab);
            localStorage.setItem("openTabs", JSON.stringify(openTabs));
        }
    }
    // get fileName(){
    //     let list = this.file.key.split('/')
    //     let name = list[list.length - 1];
    //     name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1]
    //     return name;
    // }
    get fileSelected() {
        return this.$store.state.selectFilesIndex;
    }
    selectFile(index) {
        if (this.fileSelected && this.fileSelected.length > 1 && this.fileSelected.includes(index)) {
            return;
        }
        this.$store.commit("selectFile", index);
    }
    clickFile(index) {
        if (this.fileSelected && this.fileSelected.length == 1 && this.fileSelected.includes(index)) {
            return;
        }
        this.$store.commit("selectFile", index);
    }
    selectFiles(index) {
        if (this.type === "share") {
            //share 暂时不多选。
            return;
        }
        this.$store.commit("selectFiles", index);
    }

    get top() {
        return this.$store.state.layoutTop;
    }
    set top(v) {
        this.$store.commit("setState", {
            type: "layoutTop",
            data: v,
        });
    }
    get left() {
        return this.$store.state.layoutLeft;
    }
    set left(v) {
        this.$store.commit("setState", {
            type: "layoutLeft",
            data: v,
        });
    }

    get thumbnail() {
        return this.$store.state.thumbnail;
    }
    set thumbnail(v) {
        this.$store.commit("setState", {
            type: "thumbnail",
            data: v,
        });
    }
    get thumbnailTimer() {
        return this.$store.state.thumbnailTimer;
    }
    set thumbnailTimer(v) {
        this.$store.commit("setState", {
            type: "thumbnailTimer",
            data: v,
        });
    }

    share(item) {
        console.log("toshare");
        let ts = this as any;
        if (!item) {
            item = ts.selFiles[0];
        }
        if (item.info.encrypt) {
            this.$edMessage.error(this.$t("lockedFile"));
            return;
        }
        this.$track("files", "share file");
        if (item.info && item.info.share_url) {
            let shareHtml = `<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" width=800 height=800 src="${item.info.frame_url}"></iframe>'`;
            this.$store.commit("setState", { type: "shareId", data: item.info.share_id });
            // let key = item.key.match(".*?/.*?/(.*)")
            // if(key && key[1]) key = key[1];
            // this.$store.commit('setState', {type: 'shareKey', data: key})
            this.$store.commit("setState", { type: "shareLink", data: item.info.share_url });
            this.$store.commit("setState", { type: "shareLinkCode", data: item.info.share_code });
            this.$store.commit("setState", { type: "shareHTML", data: shareHtml });
            this.$store.commit("setState", {
                type: "shareData",
                data: {
                    title: item.name,
                    imgUrl: this.onlineFilesImg(
                        item.info.img,
                        item.info.down_exp || item.info.downExp,
                        item.info.img_sign || item.info.img_down_sign || item.info.imgSign,
                        item.lastModified,
                        !!item.info.img_sign
                    ),
                },
            });
            if (item.info.option) {
                this.$store.commit("setState", {
                    type: "shareType",
                    data: item.info.option,
                });
            }
            if (item.info.end_type) {
                this.$store.commit("setState", {
                    type: "shareExpire",
                    data: {
                        end_type: item.info.end_type,
                        end_time: item.info.end_time,
                    },
                });
            }
            if (!this.internal && item.info.switch) {
                this.$store.commit("setState", {
                    type: "shareUseable",
                    data: item.info.switch,
                });
            }
            this.$store.commit("setState", {
                type: "filePreview",
                data: !item.info.edit,
            });
            this.$store.commit("setState", { type: "shareState", data: true });
        } else {
            // this.selectFiles = item
            if (item.info && item.info.edit === false) {
                if (this.isPC) {
                    this.$store.commit("toPublicStatus", {
                        type: "showUpgrade",
                        data: "fileNum",
                    });
                } else {
                    let fileName = "&name=";
                    if (item.name) {
                        fileName += item.name;
                    } else if (item.title) {
                        // share file
                        fileName += item.title;
                    } else {
                        let key = item.key || item.obj;
                        fileName += key.match(/[^\/]*(?=\.eddx)/i)[0];
                    }
                    let fileKey = item.key;
                    fileName += "&preview=1&fileLimitTip=1";
                    this.$store.commit("setState", {
                        type: "showReadOnlyModal",
                        data: true,
                    });
                    let base = (<any>this.$router).options.base;
                    if (base == "/pc/") {
                        base = "/online/";
                    }
                    this.$store.commit("setState", {
                        type: "readOnlyTempFileLink",
                        data: window.location.origin + base + "app.html?" + ts.$zipFileName("obj=" + fileKey + fileName),
                    });
                }
                return;
            }
            this.$store.commit("setState", {
                type: "shareTipState",
                data: true,
            });
        }
    }

    onlineFilesImg(img, exp, sign, lastModified, newSign) {
        return this.internal
            ? `${window["GLOBAL"].PRIVATE_OSS_HOST}${img}?OSSAccessKeyId=${
                  newSign ? this.OSSAccessKeyId : "V4UkdUUAM3K63bGL"
              }&Expires=${exp}&Signature=${encodeURIComponent(sign)}&lastModified=${lastModified}`
            : `${window["GLOBAL"].PRIVATE_OSS_HOST}${img}?${sign}`;
    }
    contextmenu(e, file, index) {
        if (this.pcSaveInput) {
            return;
        }
        this.selectFile(index);
        if (this.fileSelected && this.fileSelected.includes(index)) {
            console.log(e);
            e.stopPropagation();
        }
        // 通过点击图标触发
        const isByClickIcon = e.target && e.target.nodeName == "svg";
        const targetObj = e.target && e.target.getBoundingClientRect();
        this.top = isByClickIcon ? targetObj.top + e.target.clientHeight + 6 : e.pageY;
        this.left = isByClickIcon ? targetObj.left : e.pageX;
        if (this.type === "files") {
            const contextHeight = this.isPC ? 327 : 360;
            if (document.documentElement.clientHeight - e.pageY < contextHeight) {
                this.top = document.documentElement.clientHeight - contextHeight;
            }
            if (document.documentElement.clientWidth - e.pageX < 313) {
                this.left -= 100;
            }
            this.$store.commit("setState", {
                type: "folderContextShow",
                data: false,
            });
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: true,
            });
        }
        if (this.type === "recycle") {
            if (document.documentElement.clientHeight - e.pageY < 200) {
                this.top -= 76;
            }
            if (document.documentElement.clientWidth - e.pageX < 200) {
                this.left -= 117;
            }
            this.$store.commit("setState", {
                type: "folderContextShow",
                data: false,
            });
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: true,
            });
        } else if (this.type === "share") {
            if (document.documentElement.clientHeight - e.pageY < 200) {
                this.top -= 76;
            }
            if (document.documentElement.clientWidth - e.pageX < 200) {
                this.left -= 117;
            }
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: true,
            });
        } else if (this.type === "openRecord") {
            if (document.documentElement.clientHeight - e.pageY < 200) {
                this.top -= 76;
            }
            if (document.documentElement.clientWidth - e.pageX < 200) {
                this.left -= 117;
            }
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: true,
            });
        } else if (this.type === "star") {
            if (document.documentElement.clientHeight - e.pageY < 200) {
                this.top -= 76;
            }
            if (document.documentElement.clientWidth - e.pageX < 200) {
                this.left -= 117;
            }
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: true,
            });
        } else if (this.type === "shareToMe") {
            if (document.documentElement.clientHeight - e.pageY < 200) {
                this.top -= 44;
            }
            if (document.documentElement.clientWidth - e.pageX < 200) {
                this.left -= 117;
            }
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: true,
            });
        } else if (this.type === "publishFile") {
            if (document.documentElement.clientHeight - e.pageY < 200) {
                this.top -= 108;
            }
            if (document.documentElement.clientWidth - e.pageX < 200) {
                this.left -= 117;
            }
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: true,
            });
        } else if (this.type == "openRecord") {
            if (document.documentElement.clientHeight - e.pageY < 200) {
                this.top -= 108;
            }
            if (document.documentElement.clientWidth - e.pageX < 200) {
                this.left -= 120;
            }
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: true,
            });
        } else if (this.type === "team") {
            if (document.documentElement.clientHeight - e.pageY < 200) {
                this.top -= 108;
            }
            if (document.documentElement.clientWidth - e.pageX < 200) {
                this.left -= 120;
            }
            this.$store.commit("setState", {
                type: "teamContextShow",
                data: false,
            });
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: true,
            });
        }
        this.$bus.$emit("fixContextPosition");

        // this.folderMenuBoxShow = false
        // this.contextmenuBoxShow = true
        // this.selectFiles = files
        // if(this.fileSelected.length > 1){

        // }else{
        //     this.selectFile(index);
        // }
    }

    // 特殊标签
    get fileTag() {
        if (this.type == "files" && this.file.info) {
            if (this.file.info.publish == "pass") {
                return "passPublish";
            } else if (this.file.info.share_url) {
                return "tag_share";
            }
        }
        return "";
    }
    isDialog = false;
    mounted() {
        let urlParmas = new URLSearchParams(location.search.substr(1));
        this.isDialog = !!urlParmas.get("dialog");
    }
}
